// extracted by mini-css-extract-plugin
export default {"nonBlockingSyncLoader":"nonBlockingSyncLoader_nonBlockingSyncLoader__nJ0D+"};